import Http from '../api/http/';

export default class Label extends Http {
  constructor() {
    super();
  }
  // 新增标签分类
  label_addLabelClassInfo() {
    return super.post('label/addLabelClassInfo', ...arguments);
  }
  // 编辑标签分类
  label_updateLabelClassInfo() {
    return super.post('label/updateLabelClassInfo', ...arguments);
  }
  // 查询所有标签分类
  label_getAllLabelClass() {
    return super.post('label/getAllLabelClass', ...arguments);
  }
  // 删除标签分类
  label_deleteLabelClassInfo() {
    return super.post('label/deleteLabelClassInfo', ...arguments);
  }
  // 查询标签列表
  label_getLabelList() {
    return super.post('label/getLabelList', ...arguments);
  }
  // 新增标签
  label_addLabel() {
    return super.post('label/addLabel', ...arguments);
  }
  // 编辑标签
  label_updateLabel() {
    return super.post('label/updateLabel', ...arguments);
  }
  // 删除标签
  label_deleteLabel() {
    return super.post('label/deleteLabel', ...arguments);
  }
  // 标签变更记录
  label_getLabelLogs() {
    return super.post('label/getLabelLogs', ...arguments);
  }
  // 批量打用户标签
  label_batchImportUserLabel() {
    return super.post('label/batchImportUserLabel', ...arguments);
  }
  // 查询标签 b端
  label_getClassAndLabelList() {
    return super.post('label/getClassAndLabelList', ...arguments);
  }
  // 新增标签（用户标记）
  label_addUserLabel() {
    return super.post('label/addUserLabel', ...arguments);
  }
  // 删除标签（用户标记）
  label_deleteUserLabel() {
    return super.post('label/deleteUserLabel', ...arguments);
  }
  /**
   * @description 查询报告关联的任务标签
   * @param {Number} reportLogId -  reportLogId
   */
  label_getLabelListForReport() {
    return super.post('label/getLabelListForReport', ...arguments);
  }
  /**
   * @description 获取报告下的用户的所有标签
   * @param {Number} reportLogId - 报告日志ID
   */
  label_getUserLabelInfosByReportLogId() {
    return super.post('label/getUserLabelInfosByReportLogId', ...arguments);
  }
}
